import { render, staticRenderFns } from "./Tnc.vue?vue&type=template&id=fb765cee&scoped=true"
import script from "./Tnc.vue?vue&type=script&lang=js"
export * from "./Tnc.vue?vue&type=script&lang=js"
import style0 from "./Tnc.vue?vue&type=style&index=0&id=fb765cee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb765cee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb765cee')) {
      api.createRecord('fb765cee', component.options)
    } else {
      api.reload('fb765cee', component.options)
    }
    module.hot.accept("./Tnc.vue?vue&type=template&id=fb765cee&scoped=true", function () {
      api.rerender('fb765cee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/footer-pages/tnc/Tnc.vue"
export default component.exports